<template>
<div>
  <b-form-select v-model="client_id" value-field="id" text-field="name" @change="changeClientGlobal">
    <b-form-select-option  :key="index"  v-for="(client, index) in availableClientList" :value="client.id">{{client.name}}</b-form-select-option>
  </b-form-select>
</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ChangeClient",
  data() {
    return {
      client_id: null,
    };
  },
  computed:{
    ...mapGetters('client', ['availableClientList', 'client'])
  },
  methods: {
    changeClientGlobal(clientId){
      if(clientId) {
        this.$store.dispatch('client/actionSetClient', clientId)
      }
    }
  },
  watch: {
    client: {
      handler(clientObject) {
        if (clientObject && clientObject.id) {
          this.client_id = clientObject.id
        }
      }, immediate: true
    },
  }
}
</script>

<style scoped>

</style>
